import { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import api, { errMsg } from "@/lib/api";
import { t } from "@/i18n";

const EXAMPLES = [
  t("aiAssistant.burger_avec_180_g_de_boeuf_cheddar_tomate"),
  t("aiAssistant.tartare_de_saumon_150_g_avocat_citron_vert"),
  t("aiAssistant.tiramisu_maison_au_mascarpone_et_cafe"),
];

export default function AiAssistant({ onResult }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async () => {
    if (text.trim().length < 3) return;
    setBusy(true);
    try {
      const { data } = await api.post("/recipes/ai-generate", { text }, { timeout: 120000 });
      onResult(data);
      toast.success(t("aiAssistant.recette_generee_verifiez_et_ajustez_les_qu"));
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mb-6 rounded-2xl border border-[hsl(var(--ai)/0.3)] bg-gradient-to-br from-[hsl(var(--ai)/0.08)] to-transparent p-5 fade-up" data-testid="ai-recipe-assistant">
      <div className="mb-3 flex items-center gap-2">
        <Sparkles className="h-4 w-4 text-[hsl(var(--ai))]" />
        <p className="font-semibold">{t("aiAssistant.assistant_recette_ia")}</p>
      </div>
      <Textarea rows={3} value={text} onChange={(e) => setText(e.target.value)} placeholder={t("aiAssistant.decrivez_votre_plat_ex_burger_avec_180_g_d")} data-testid="ai-recipe-assistant-input" className="bg-background/70" />
      <div className="mt-3 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex flex-wrap gap-1.5">
          {EXAMPLES.map((ex, i) => (
            <button key={i} type="button" onClick={() => setText(ex)} className="rounded-full border bg-background/60 px-2.5 py-1 text-xs text-muted-foreground transition-colors hover:text-foreground" data-testid={`ai-recipe-example-${i}`}>
              {ex.split(" ").slice(0, 3).join(" ")}…
            </button>
          ))}
        </div>
        <Button onClick={run} disabled={busy || text.trim().length < 3} className="bg-[hsl(var(--ai))] text-white hover:bg-[hsl(var(--ai)/0.9)]" data-testid="generate-recipe-btn">
          {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Sparkles className="mr-2 h-4 w-4" />}{t("aiAssistant.generer_la_fiche")}
        </Button>
      </div>
    </div>
  );
}
